import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, FileCheck, TrendingUp, CheckCircle } from 'lucide-react';

const TaxRecovery = () => {
  const benefits = [
    'Análise completa de tributos pagos nos últimos 5 anos',
    'Identificação de pagamentos indevidos ou a maior',
    'Recuperação de PIS, COFINS, ICMS, IPI e outros tributos',
    'Acompanhamento de todo processo de restituição',
    'Consultoria para otimização tributária futura',
    'Equipe especializada em legislação tributária'
  ];
  const steps = [
    {
      icon: FileCheck,
      title: 'Análise Detalhada',
      description: 'Revisamos toda documentação fiscal dos últimos 5 anos'
    },
    {
      icon: DollarSign,
      title: 'Identificação',
      description: 'Localizamos tributos pagos indevidamente ou a maior'
    },
    {
      icon: TrendingUp,
      title: 'Recuperação',
      description: 'Realizamos todo processo de restituição junto aos órgãos competentes'
    }
  ];

  return (
    <section id="tax-recovery" className="py-20 bg-[#0a4b3c] text-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-[#c99b36] font-semibold text-lg mb-2 block">Recuperação Tributária</span>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">Recupere Impostos Pagos Indevidamente</h2>
            <p className="text-white/90 text-lg mb-6 max-w-2xl">
              Nossa equipe especializada identifica e recupera valores pagos indevidamente, garantindo que sua empresa recupere recursos e melhore o fluxo de caixa.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              {benefits.slice(0,4).map((b, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#c99b36] text-white flex items-center justify-center shadow">
                    <CheckCircle className="w-5 h-5" />
                  </div>
                  <p className="text-white/90">{b}</p>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="rounded-2xl shadow-2xl overflow-hidden border border-white/10 bg-white/5">
              <div className="w-full h-96 bg-white/5">
                <img
                  src="/images/contabilidade.jpg"
                  alt="Contabilidade"
                  className="w-full h-96 object-cover"
                />
              </div>
            </div>

            {/* banner removed as requested */}
          </motion.div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          <div className="bg-white/5 rounded-xl p-6 shadow">
            <h4 className="text-xl font-bold text-white mb-2">Como funciona</h4>
            <p className="text-white/80">Analisamos sua documentação, identificamos oportunidades e conduzimos o processo de recuperação junto aos órgãos competentes.</p>
          </div>
          <div className="bg-white/5 rounded-xl p-6 shadow">
            <h4 className="text-xl font-bold text-white mb-2">Prazo</h4>
            <p className="text-white/80">O prazo depende de cada situação. Após a análise inicial, nossa equipe retorna com uma estimativa.</p>
          </div>
          <div className="bg-white/5 rounded-xl p-6 shadow">
            <h4 className="text-xl font-bold text-white mb-2">Garantia</h4>
            <p className="text-white/80">Trabalhamos com transparência e relatórios periódicos durante todo o processo.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TaxRecovery;